import { render } from "./ValidateData.vue?vue&type=template&id=c893cb00"
import script from "./ValidateData.vue?vue&type=script&lang=js"
export * from "./ValidateData.vue?vue&type=script&lang=js"

import "./ValidateData.vue?vue&type=style&index=0&id=c893cb00&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__